function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { forwardRef, useRef, useContext, useEffect, useImperativeHandle } from 'react';
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import { StateManagerContext } from '../state-manager';

var syncRef = function syncRef(source, target) {
  /* istanbul ignore else */
  if (typeof target === 'function') {
    target(source.current);
  } else if (target) {
    ;
    target.current = source.current;
  }
};

var BaseChart = function BaseChart(props, ref) {
  var Chart = props.chart,
      stateManagerCfg = props.stateManager,
      style = props.style,
      className = props.className,
      chart = props.chartRef,
      restProps = _objectWithoutProperties(props, ["chart", "stateManager", "style", "className", "chartRef"]);

  var chartRef = useRef(null);
  var configRef = useRef();
  var containerRef = useRef(null);
  var stateManager = useContext(StateManagerContext);
  var isFirstRenderRef = useRef(true);
  useImperativeHandle(ref, function () {
    return containerRef.current;
  });
  useEffect(function () {
    var container = containerRef.current;
    /* istanbul ignore else */

    if (container) {
      var _ref = restProps,
          _ref$data = _ref.data,
          data = _ref$data === void 0 ? [] : _ref$data,
          config = _objectWithoutProperties(_ref, ["data"]);

      configRef.current = cloneDeep(config);

      var mergedConfig = _objectSpread(_objectSpread({}, config), {}, {
        data: data
      });

      chartRef.current = new Chart(container, mergedConfig);
      chartRef.current.render();
      /* istanbul ignore else */

      if (stateManager && stateManagerCfg) {
        chartRef.current.bindStateManager(stateManager, stateManagerCfg);
      }
    }

    syncRef(chartRef, chart);
    return function () {
      /* istanbul ignore else */
      if (chartRef.current) {
        chartRef.current.destroy();
        chartRef.current = null;
        syncRef(chartRef, chart);
      }
    }; // eslint-disable-next-line
  }, []);
  useEffect(function () {
    var chart = chartRef.current;
    /* istanbul ignore else */

    if (chart) {
      // avoid update in first time
      if (!isFirstRenderRef.current) {
        var _ref2 = restProps,
            data = _ref2.data,
            config = _objectWithoutProperties(_ref2, ["data"]);

        if (!isEqual(config, configRef.current)) {
          configRef.current = cloneDeep(config);
          chart.updateConfig(config);
          chart.render();
        } else {
          if (data) {
            chart.changeData(data);
          } else {
            chart.changeData([]);
          }
        }
      } else {
        isFirstRenderRef.current = false;
      }
    }
  }, [restProps]);
  return (
    /*#__PURE__*/
    React.createElement("div", {
      style: style,
      className: className,
      ref: containerRef
    })
  );
};

export default forwardRef(BaseChart);